import { ISSUER_RATES } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  content: [],
  transferType: [],
  ratesStatus: undefined,
  ratesError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ISSUER_RATES.FETCH:
      return {
        ...state,
        ratesStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case ISSUER_RATES.SUCCESS:
      return {
        ...state,
        ...action.payload,
        ratesStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case ISSUER_RATES.FAILED:
      return {
        ...state,
        ratesError: action.payload,
        ratesStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case ISSUER_RATES.TRANSFERTYPE_SUCCESS:
      return {
        ...state,
        transferType: action.payload,
      };
    default:
      return state;
  }
};
